import { parsePhoneNumberFromString, getCountries, getCountryCallingCode } from 'libphonenumber-js';

// 국가 전화코드(+82) → ISO 국가코드(KR) 변환 맵 //
const callingCodeToCountry = (() => {
  const map = {};

  for (const country of getCountries()) {
    const code = '+' + getCountryCallingCode(country);
    if (!map[code]) map[code] = country;
  }

  return map;
})();

// 전화번호 포맷 변환 //
// languageMode가 'ko'이거나 미전달이면 +82 번호를 국내 포맷으로, 그 외엔 국제 포맷으로 반환
function formatPhoneNumber(phone, countryCode, languageMode) {
  if (!phone || phone === '') return '';

  const cleanPhone = phone.replaceAll('-', '');
  const isKorean = (!countryCode || countryCode === '+82') && (languageMode === undefined || languageMode === 'ko');

  try {
    if (isKorean) {
      const parsed = parsePhoneNumberFromString(cleanPhone, 'KR');
      if (parsed && parsed.isPossible()) return parsed.formatNational().replaceAll('-', ' ');
    }
    else {
      const resolvedCode = countryCode || '+82';
      const country = callingCodeToCountry[resolvedCode] ?? 'KR';

      // E.164 형식으로 파싱 시도 (지역코드 유효성 검사 우회) //
      const e164 = cleanPhone.startsWith('+') ? cleanPhone : resolvedCode + cleanPhone;
      const parsedE164 = parsePhoneNumberFromString(e164);
      if (parsedE164) return parsedE164.formatInternational().replaceAll('-', ' ');

      // 국가 힌트로 파싱 시도 //
      const parsed = parsePhoneNumberFromString(cleanPhone, country);
      if (parsed) return parsed.formatInternational().replaceAll('-', ' ');

      return resolvedCode + ' ' + cleanPhone;
    }
  }
  catch {
    // fallback
  }

  return cleanPhone;
}

// 업체/센터 전화번호 포맷 //
function formatStoreTel(storeTel) {
  if (!storeTel || storeTel === '') return '';

  const cleanTel = storeTel.replaceAll('-', '');

  try {
    const parsed = parsePhoneNumberFromString(cleanTel, 'KR');
    if (parsed) return parsed.formatNational().replaceAll('-', ' ');
  }
  catch {
    // fallback
  }

  return cleanTel;
}

export { formatPhoneNumber, formatStoreTel };
